var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 11c-2.7614 0-5 2.2386-5 5 0 2.7615 2.2386 5 5 5 2.7615 0 5-2.2385 5-5 0-2.7614-2.2385-5-5-5zm-3 5c0-1.6568 1.3432-3 3-3s3 1.3432 3 3-1.3432 3-3 3-3-1.3432-3-3z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 4.3333c-6.0188 0-10.073 3.6056-12.426 6.6625l-0.04243 0.0551c-0.53213 0.6911-1.0222 1.3276-1.3547 2.0803-0.35607 0.806-0.51025 1.6844-0.51025 2.8688s0.15418 2.0628 0.51025 2.8688c0.33249 0.7526 0.8226 1.3892 1.3548 2.0802l0.0424 0.0551c2.353 3.0569 6.4071 6.6625 12.426 6.6625 6.0188 0 10.073-3.6056 12.426-6.6625l0.0424-0.0551c0.5323-0.691 1.0224-1.3276 1.3549-2.0802 0.356-0.806 0.5102-1.6844 0.5102-2.8688s-0.1542-2.0628-0.5102-2.8688c-0.3325-0.7527-0.8226-1.3892-1.3549-2.0803l-0.0424-0.0551c-2.3529-3.0569-6.4071-6.6625-12.426-6.6625zm-10.841 7.8824c2.1726-2.8225 5.7082-5.8824 10.841-5.8824s8.6686 3.0599 10.841 5.8824c0.5848 0.7597 0.9272 1.2137 1.1525 1.7236 0.2107 0.4767 0.3398 1.0592 0.3398 2.0607 0 1.0014-0.1291 1.584-0.3398 2.0606-0.2253 0.5099-0.5677 0.9639-1.1525 1.7236-2.1725 2.8226-5.7083 5.8824-10.841 5.8824s-8.6685-3.0598-10.841-5.8824c-0.58477-0.7597-0.92731-1.2137-1.1526-1.7236-0.21056-0.4766-0.33968-1.0592-0.33968-2.0606 0-1.0015 0.12912-1.584 0.33968-2.0607 0.2253-0.5099 0.56781-0.9639 1.1526-1.7236z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViews);
export default __webpack_public_path__ + "static/media/icon_views.96e317f743a3ed7460dba7d3e329af02.svg";
export { ForwardRef as ReactComponent };